import { type ComponentProps, useId } from "react";
import { Link } from "@tanstack/react-router";
import { tv } from "tailwind-variants";

import { PROGRESS_TEASER_TITLE } from "@/domains/progress/utils/progress-entry-points";
import { Card, focusRing, Heading, icons } from "@/ui";

const progressTeaserLinkVariants = tv({
  base: `group flex items-center justify-between gap-4 rounded-card p-5 transition-colors hover:bg-surface-hover sm:gap-6 sm:p-10 ${focusRing}`,
});

export type ProgressTeaserCardProps = ComponentProps<typeof Card> & {
  body: string;
};

export const ProgressTeaserCard = ({ body, ...props }: ProgressTeaserCardProps) => {
  const titleId = useId();
  const bodyId = useId();

  return (
    <Card {...props}>
      <Link
        aria-describedby={bodyId}
        aria-labelledby={titleId}
        className={progressTeaserLinkVariants()}
        to="/progress"
      >
        <div className="flex flex-col gap-2 sm:gap-3">
          <Heading className="transition-colors group-hover:text-accent" id={titleId} level={2}>
            {PROGRESS_TEASER_TITLE}
          </Heading>

          <p
            className="text-base leading-6 text-content-secondary sm:text-xl sm:leading-8"
            id={bodyId}
          >
            {body}
          </p>
        </div>

        <icons.ArrowRight
          aria-hidden="true"
          className="size-7 shrink-0 text-content transition-transform group-hover:translate-x-1 motion-reduce:transition-none"
        />
      </Link>
    </Card>
  );
};
